export default __webpack_public_path__ + "fb922208fbf5be8efedaca35668fc8af.png";